import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { OrderComponent } from './order/components/order/order.component';
import { OrderModule } from './order/order.module';
import { PurchaseModule } from './purchase/purchase.module';
import { SettingModule } from './setting/setting.module';

const routes: Routes = [
  { path: 'purchases', loadChildren: () => PurchaseModule },
  { path: 'order', loadChildren: () => OrderModule, component: OrderComponent },
  { path: 'setting', loadChildren: () => SettingModule },
  { path: '', pathMatch: 'full', redirectTo: 'purchases' },
  { path: 'payment-success', component: PaymentSuccessComponent, data: { success: true } },
  { path: 'payment-fail', component: PaymentSuccessComponent, data: { success: false } },
  { path: 'process-payment', component: PaymentSuccessComponent, data: { success: false } }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthorizedRoutingModule { }
